import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InfologService } from './infolog.service';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private toastr: ToastrService, private infolog: InfologService) {  }

  info(message: string, duration: number = 5000) {
    // this.toastr.info(message, 'Info', {
    //   timeOut: 10000,
    //   positionClass: 'toast-top-right',
    // });
    this.infolog.info(message);

  }

  success(message: string, duration: number = 5000) {
    // this.toastr.success(message, 'Success', {
    //   timeOut: 10000,
    //   positionClass: 'toast-top-right',
    // });
    this.infolog.success(message);
  }

  error(message: string) {
    // this.toastr.error(message, 'Error', {
    //   timeOut: 10000,
    //   positionClass: 'toast-top-right',
    // });
    this.infolog.error(message);
  }
  warning(message: string) {
    // this.toastr.warning(message, 'Warning', {
    //   timeOut: 10000,
    //   positionClass: 'toast-top-right',
    // });
    this.infolog.warning(message);

  }
}
